import { getAppProps } from '@/Navigation';
import { isIOS } from '@kibt/krn-utils';
import { useEffect, useState } from 'react';
import { useIsFocused } from './useIsFocused';
import { Dimensions } from 'react-native';
import { isFixedViewSupport } from '@/component/FixedView';

/**
 * android使用fixed固底方案
 */
export function useFixedPosition() {
    const isFocused = useIsFocused();
    const [position, setPosition] = useState<'fixed' | 'relative'>(isFocused && !isFixedViewSupport ? 'fixed' : 'relative');

    useEffect(() => {
        setPosition(isFocused && !isFixedViewSupport ? 'fixed' : 'relative');
    }, [isFocused]);

    return position;
}

/**
 * @deprecated
 * iOS使用吸底Tag固底方案
 * 不好使，需要艾静解决
 */
export function useIosFixedNativeID() {
    const isFocused = useIsFocused();

    /**
     * 1.iOS视图固定， 只需要初始化时固底就行， 中间webview高度变化不需要再次计算
     * 2.SPA多视图固定方案，iOS实现中，不要影响当前的方式
     */
    const { foldRatio = 1 } = getAppProps();
    const bottom = Dimensions.get('window').height * (1 - foldRatio);

    const [state, setState] = useState({
        nativeID: isFocused && isIOS ? 'krn_bottom_sheet_view_id' : '',
        bottom: bottom,
    });

    // 监听路由改动
    // useEffect(() => {
    //     console.log('useEffect half bottom', bottom, foldRatio);
    //     setState((pre) => ({
    //         ...pre,
    //         nativeID: isFocused && isIOS ? 'krn_bottom_sheet_view_id' : '',
    //     }));
    // }, [isFocused]);

    // // 容器上下滑高度改变
    // const onContainerHeightChange = async () => {
    //     // 从容器参数获取半屏的高度比例
    //     const { foldRatio = 1 } = getAppProps();
    //     const res = await yoda.component.isHalfContainerStatus({});
    //     // {"height": 896, "isHalf": 0, "result": 1}
    //     if (res.isHalf && isIOSKDS) {
    //         // 如果是半屏
    //         if (state.bottom !== res.height) {
    //             const bottom = res.height * (1 - foldRatio);
    //             setState((pre) => ({
    //                 ...pre,
    //                 bottom,
    //             }));
    //         }
    //     } else {
    //         // 全屏
    //         if (state.bottom !== res.height) {
    //             const bottom = res.height * (1 - foldRatio);
    //             setState((pre) => ({
    //                 ...pre,
    //                 bottom: bottom,
    //             }));
    //         }
    //     }
    // };
    // useEffect(() => {
    //     // 第一次主动请求
    //     // onContainerHeightChange();
    //     // // 后面增加高度监听
    //     // yoda.event.addEventListener('krn_bottom_sheet_on_sliding_status_change', onContainerHeightChange);
    //     // return () => {
    //     //     yoda.event.removeEventListener('krn_bottom_sheet_on_sliding_status_change', onContainerHeightChange);
    //     // };
    // }, []);

    return state;
}
